<template>
  <a-drawer placement="right" :closable="false" :mask-closable="false" :visible="visible"
            width="1200"  :body-style="{'padding':'10px 24px','box-sizing':'border-box','height':'92%','overflow':'auto'}">
    <div slot="title" class="gpws-drawer-title-span">
      <div class="gpws-drawer-close" @click="()=>onDrawerClose()"><a-icon type="close" style="margin-right: 3px" />关闭</div>
      <span class="gpws-drawer-title">远程辅诊</span>
      <span></span>
    </div>
    <a-spin :spinning="loading" :tip="loadTip">
      <a-steps size="small" type="navigation" :current="currstep" style="padding-top: 0px;">
        <a-step title="预约专家">
          <a-icon slot="icon" type="team"/>
        </a-step>
        <a-step title="辅诊申请">
          <a-icon slot="icon" type="edit"/>
        </a-step>
        <a-step title="病历资料">
          <a-icon slot="icon" type="solution"/>
        </a-step>
      </a-steps>
      <a-card :bordered="false" v-if="currstep == 0" size="small" :head-style="{'borderBottom':'none'}"
              :body-style="{'padding':'0px'}">
        <a-row>
          <a-col span="6">
            <a-card size="small" :bordered="false"
                    :head-style="{'background':'rgba(236, 243, 246, 0.8)', 'borderBottom':'none', 'paddingLeft':'12px', 'paddingRight':'12px'}"
                    :body-style="{'padding':'0px'}">
              <span slot="title" style="font-size: 16px;font-family: Alibaba PuHuiTi;font-weight: 500;color: #3A3A3A;">
                专家列表
              </span>
              <template v-if="(experts||[]).filter(m => (m.id !=(current.doctorId||''))).length > 0">
                <template v-for="item in (experts||[]).filter(m => (m.id !=(current.doctorId||'')))">
                  <a-row :key="'d-'+item.organId+'-'+item.id" :class="'gpws-doctor-row'+(item.id == doctorId?' gpws-doctor-row-selected':'')">
                    <a-col span="6" @click="onExpertChange(item.organId, item.id)">
                      <a-avatar :size="50" :src="doctorAvater" style="margin: 6px;"/>
                    </a-col>
                    <a-col span="18" @click="onExpertChange(item.organId, item.id)">
                      <a-row style="margin: 6px;">
                        <a-col style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                          <span
                              style="font-size: 16px;font-family: Alibaba PuHuiTi;font-weight: 400;color: #484848;margin-right: 10px;">
                            {{ item.name }}
                            <span v-if="item.online">(<label style="color: #1890ff;font-size: 13px;font-weight: bold;">在线</label>)</span>
                          </span>
                          <span
                              style="font-size: 13px;font-family: Alibaba PuHuiTi;font-weight: 400;color: #B8B8B8;">{{ item.organName }}</span>
                        </a-col>
                        <a-col style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                          <span
                              style="font-size: 13px;font-family: Alibaba PuHuiTi;font-weight: 400;color: #B8B8B8;">{{ item.departName }}&nbsp;{{ item.profession || ' ' }}</span>
                        </a-col>
                      </a-row>
                    </a-col>
                  </a-row>
                </template>
              </template>
              <template v-else>
                <span style="line-height: 40px;color: #d02f2f;">当前平台无远程辅诊医生.</span>
              </template>
            </a-card>
          </a-col>
          <a-col span="18">
            <a-calendar v-model="scheduleDate" :disabled-date="disabledDate" mode="month" @select="scheduleDateSelect"
                        @panelChange="onPanelChange">
              <div slot="dateCellRender" slot-scope="value">
                <div v-if="getScheduleDate(value)">
                  <div
                      style="display:inline-flex;position:absolute; top: 50%; left: 50%;-webkit-transform: translateX(-50%) translateY(-50%);">
                    <div :class="'gpws-schedule-reserve-span'+(scheduleDate == value.format('YYYY-MM-DD')?' gpws-schedule-reserve-span-selected':'')">
                      可预约
                    </div>
                    <div :class="'gpws-schedule-reserve'+(scheduleDate == value.format('YYYY-MM-DD')?' gpws-schedule-reserve-selected':'')">
                      {{ getScheduleDate(value).reserveNumber }}
                    </div>
                  </div>
                </div>
              </div>
            </a-calendar>
          </a-col>
        </a-row>
      </a-card>
      <a-card :bordered="false" v-if="currstep == 1" size="small" :head-style="{'borderBottom':'none'}"
              :body-style="{'padding':'0px'}">
        <a-form :form="telemed.form" layout="horizontal">
          <a-card :bordered="false" size="small"
                  :head-style="{'borderBottom':'none', 'paddingLeft':'24px', 'paddingRight':'24px'}"
                  :body-style="{'padding':'0px'}">
            <span slot="title"
                  style="font-size: 18px;font-family: Alibaba PuHuiTi;font-weight: 500;color: #000000;">
              <img src="../../../assets/img/date.png"
                   style="width:17px;height:17px;margin-right: 9px;user-select: none;margin-top: -4px;"/>预约时间
            </span>
            <a-row>
              <a-col :xxl="12" :xl="12" :lg="12" :md="12" :sm="12" :xs="24">
                <a-form-item :colon="false" label="预约时段" class="gpws-m-b-12" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }"
                             style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                  <a-tag color="blue"
                         style="font-weight: 500;height:32px; line-height:32px;padding-right: 4px;padding-left: 4px;">
                    {{ scheduleDate }}
                  </a-tag>
                  <a-select
                      v-decorator="['scheduleId', {rules: [{ required: true, message: '辅诊预约时段必须选择!' }], initialValue:'' }]"
                      placeholder="请选择辅诊预约时段">
                    <a-select-option v-for="(e, i) in (intervals||[]).filter(m => (m.reservedNumber < m.peopleNumber))"
                                     :key="'s-i-'+(i+1)" :value="e.id">
                      {{ e.startTime }}&nbsp;--&nbsp;{{ e.endTime }}&nbsp;&nbsp;(已预约:<span
                        style="color: #D02F2F;">{{ e.reservedNumber }}</span>&nbsp;/&nbsp;总人数:<span
                        style="color: #D02F2F;">{{ e.peopleNumber }}</span>)
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xxl="4" :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                <a-form-item label="辅诊费" class="gpws-m-b-12" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                  ¥&nbsp;<span style="color: #D02F2F;font-size: 18px;font-weight: 500;">{{ feeMoney }}</span>
                </a-form-item>
              </a-col>
              <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
                <a-form-item :colon="false" label="支付方式" class="gpws-m-b-12" :label-col="{sm: 24, md: 12, lg: 5, xl: 5, xxl: 5 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                  <a-select
                      v-decorator="['payMethod', {rules: [{ required: true, message: '支付方式必须选择!' }], initialValue:'' }]"
                      placeholder="请选择支付方式">
                    <a-select-option v-for="e in paymethods" :value="e.code" :key="e.code">{{
                        e.name
                      }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </a-card>
          <a-card :bordered="false" size="small"
                  :head-style="{'borderBottom':'none', 'paddingLeft':'24px', 'paddingRight':'24px'}"
                  :body-style="{'padding':'0px'}">
            <span slot="title"
                  style="font-size: 18px;font-family: Alibaba PuHuiTi;font-weight: 500;color: #000000;">
              <img src="../../../assets/img/member.png"
                   style="width:17px;height:17px;margin-right: 9px;user-select: none;margin-top: -4px;"/>患者信息
            </span>
            <a-row>
              <a-col style="margin-left: 60px;">
                <a-form-item class="gpws-m-b-10">
                  <a-radio-group v-model="record.visitType">
                    <a-radio value="INITIAL_VISIT"><label :style="record.visitType == 'INITIAL_VISIT'?'color: #1890ff;':''">初诊患者</label></a-radio>
                    <a-radio value="SUBSEQUENT_VISIT"><label :style="record.visitType == 'SUBSEQUENT_VISIT'?'color: #1890ff;':''">复诊患者</label></a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
                <a-form-item :colon="false" label="姓名" class="gpws-m-b-12" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                  <a-input v-decorator="['name', { rules: [{ required: true, message: '就诊人姓名必须填写!' }] , initialValue: record.name}]"
                      placeholder="请填写就诊人姓名" @change="loadHistoryOutpatients">
                    <span v-if="current.readIdcard" slot="addonAfter" style="cursor: pointer;" @click="readIdcard">读取身份证</span>
                  </a-input>
                  <div v-if="history.opened" style="width: 400px;height:200px;overflow-y:auto;z-index: 999;position: absolute;background:rgb(250, 250, 250);">
                    <a-table :bordered="true" :columns="history.columns" row-key="id" :customRow="historyCustomRow" :data-source="history.datas" size="small" :pagination="false">
                      <template slot="title" slot-scope="currtable">
                        <a-row>
                          <a-col span="23" style="font-family:Alibaba PuHuiTi; font-weight: 500; color: rgb(0, 0, 0);">历史就诊记录</a-col>
                          <a-col span="1"><a-icon type="close" @click="onCloseHistory"/></a-col>
                        </a-row>
                      </template>
                    </a-table>
                  </div>
                </a-form-item>
              </a-col>
              <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
                <a-form-item :colon="false" label="身份证号" class="gpws-m-b-12" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                  <a-input v-decorator="['idcard', { rules: [{ required: true, message: '就诊人身份证号必须填写!' },{ pattern: '((^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}$)|(^\\d{6}(18|19|20)?\\d{2}(0[1-9]|1[012])(0[1-9]|[12]\\d|3[01])\\d{3}(\\d|[xX])$))',
          message: '就诊人身份证号格式错误'}] , initialValue: record.idcard}]" placeholder="请填写就诊人身份证号" @blur="onBlurIdcard"/>
                </a-form-item>
              </a-col>
              <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
                <a-form-item :colon="false" label="年龄" class="gpws-m-b-12" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }" style="white-space: nowrap;">
                  <a-input-number :min="0" :step="1" :max="120"
                                  v-decorator="['year', { rules: [{ required: true, message: '就诊人年龄必须填写!' }] , initialValue: record.year}]"
                                  placeholder="请填写就诊人年龄" style="width: 80px;min-width: 60px;"
                                  @change="gestateAgeChange"/>
                  岁
                  <a-input-number :min="0" :step="1" :max="12" v-model="record.month" placeholder="请填写就诊人年龄"
                                  style="width: 80px;min-width: 60px;" @change="gestateAgeMonthChange"/>
                  个月
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
                <a-form-item :colon="false" label="电话号码" class="gpws-m-b-12" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                  <a-input v-decorator="['phone', { rules: [{ required: true, message: '就诊人电话号码必须填写!' },{pattern: '^\\d{3,4}[-]\\d{8}$|^[1]([3-9])[0-9]{9}$', message: '就诊人电话号码(手机号码/座机号)格式错误,座机格式:XXXX[XXX]-XXXXXXXX'}] , initialValue: record.phone}]"
                      placeholder="请填写就诊人电话号码"/>
                </a-form-item>
              </a-col>
              <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
                <a-form-item :colon="false" label="性别" class="gpws-m-b-12" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                  <a-select
                      v-decorator="['sex', {rules: [{ required: true, message: '就诊人性别必须选择!' }], initialValue: record.sex }]"
                      placeholder="请选择就诊人性别" @change="gestateSexChange">
                    <a-select-option value="MALE">男</a-select-option>
                    <a-select-option value="FEMALE">女</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
                <a-form-item :colon="false" label="孕否" class="gpws-m-b-12" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 15, xl: 15, xxl: 15 }">
                  <a-select :disabled="!telemed.gestate" style="width: 100%"
                            v-decorator="['gestate', {rules: [{ required: telemed.gestate, message: '就诊人是否怀孕必须选择!' }], initialValue: ((record.gestate||false) === true ?'true':'false') }]"
                            placeholder="请选择就诊人是否怀孕">
                    <a-select-option value="true">孕</a-select-option>
                    <a-select-option value="false">否</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
                <a-form-item :colon="false" label="婚否" class="gpws-m-b-12" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                  <a-select style="width: 100%" v-decorator="['marriage', {rules: [{ required: false }], initialValue: record.marriage }]" placeholder="请选择就诊人婚姻状况">
                    <a-select-option v-for="e in init.marriages" :value="e.name" :key="e.name">{{
                        e.value
                      }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xxl="10" :xl="10" :lg="10" :md="24" :sm="24" :xs="24">
                <a-form-item :colon="false" label="详细地址" class="gpws-m-b-12" :label-col="{sm: 24, md: 12, lg: 3, xl: 3, xxl: 3 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 19, xl: 19, xxl: 19 }" style="white-space: nowrap;">
                  <a-select @change="loadCitys" style="width: 100px;" v-model="record.province">
                    <a-select-option v-for="(item, index) in init.provinces" :key="'p' + index" :value="item.id"
                                     :label="item.name">{{ item.name }}
                    </a-select-option>
                  </a-select>
                  省
                  <a-select @change="loadCountys" v-model="record.city" style="width: 100px;">
                    <a-select-option v-for="(item, index) in init.citys" :key="'c' + index" :value="item.id"
                                     :label="item.name">{{ item.name }}
                    </a-select-option>
                  </a-select>
                  市
                  <a-select v-model="record.county" style="width: 100px;" @change="getCounty">
                    <a-select-option v-for="(item, index) in init.countys" :key="'x' + index" :value="item.id"
                                     :label="item.name">{{ item.name }}
                    </a-select-option>
                  </a-select>
                  县/区
                </a-form-item>
              </a-col>
              <a-col :xxl="6" :xl="6" :lg="6" :md="24" :sm="24" :xs="24">
                <a-form-item :colon="false" class="gpws-m-b-12"
                             :wrapper-col="{sm: 24, md: 12, lg: 20, xl: 20, xxl: 20 }">
                  <a-input v-model="record.address" placeholder="请填写就诊人详细地址"/>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
                <a-form-item :colon="false" label="体温" class="gpws-m-b-12" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                  <a-input-number :min="33" :max="42" :step="0.1" style="width: 90%"
                                  v-decorator="['temperature', {rules: [{ required: false }], initialValue: record.temperature }]"
                                  placeholder="请输入患者体温"/>
                  ℃
                </a-form-item>
              </a-col>
              <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
                <a-form-item :colon="false" label="血压" class="gpws-m-b-12" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }" style="white-space: nowrap;">
                  <a-input-number :min="60" :step="1" :max="200" v-model="record.sbp" placeholder="收缩压"
                                  style="width: 80px;min-width: 60px;"/>
                  mmHg/
                  <a-input-number :min="40" :step="1" :max="160" v-model="record.dbp" placeholder="舒张压"
                                  style="width: 80px;min-width: 60px;"/>
                  mmHg
                </a-form-item>
              </a-col>
              <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
                <a-form-item :colon="false" label="血糖" class="gpws-m-b-12" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                  <a-input-number :min="1" :max="30" :step="0.1" style="width: 70%"
                                  v-decorator="['glu', {rules: [{ required: false }], initialValue: record.glu }]"
                                  placeholder="请输入患者血糖"/>
                  mmol/L
                </a-form-item>
              </a-col>

            </a-row>
            <a-row>
              <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                <a-form-item :colon="false" label="主诉" class="gpws-m-b-12" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                  <a-input v-decorator="['complaint', {rules: [{ required: false }], initialValue: record.complaint }]"
                           placeholder="请输入患者主诉"/>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
                <a-form-item :colon="false" label="临床诊断" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                  <a-select mode="multiple" :disabled="(diseased != undefined && !diseased)" v-decorator="['diseases', {rules: [{ required: false, message: '临床诊断必须填写!' }], initialValue: (record.diseases||undefined) }]"
                            show-search :default-active-first-option="false" :show-arrow="false" :filter-option="false"
                            :not-found-content="null" @focus="handleDiseaseFocus" @deselect="handleDiseaseCancel"
                            @select="handleDiseaseSelect" @search="(value) => handleDiseaseSearch(value)"
                            placeholder="请输入疾病名称检索">
                    <a-select-option v-for="item in init.diseases" :key="item.id" :value="item.id">{{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
                <a-form-item :colon="false" label="中医主症" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                  <a-select show-search :disabled="(diseased != undefined && diseased)" v-decorator="['symptom', {rules: [{ required: false, message: '中医主症必须填写!' }], initialValue: (record.symptom||undefined) }]"
                            placeholder="请填写中医主症" :dropdown-style="{'width': '600px'}" option-label-prop="label"
                            :dropdown-match-select-width="false" :default-active-first-option="false"
                            :show-arrow="false" :filter-option="false" :not-found-content="null"
                            @search="mainSymptomSearch" @select="mainSymptomSelect">
                    <a-select-option v-for="item in init.symptoms" :key="item.id" :value="item.id" :label="item.name">
                      <a-row>
                        <a-col span="8" style="color:rgba(44, 158, 21, 1);font-weight: 400;">
                          {{ item.name }}
                        </a-col>
                        <a-col span="16" style="white-space:pre-wrap;word-wrap:break-word;overflow:hidden;">
                          <template v-if="(undefined != item.alias && null != item.alias && item.alias.length > 0)">
                            <template v-for="e in item.alias">
                              &nbsp;{{ e }}
                            </template>
                          </template>
                          &nbsp;{{ item.initial }} &nbsp; {{ item.full }}
                        </a-col>
                      </a-row>
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
                <a-form-item :colon="false" label="中医辨证" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 15, xl: 15, xxl: 15 }">
                  <a-select mode="multiple"
                            v-decorator="['syndromes', {rules: [{ required: false, message: '中医辨证必须填写!' }], initialValue: (record.syndromes||undefined) }]"
                            placeholder="请填写中医辨证">
                    <a-select-option v-for="(e,i) in init.syndromes" :value="e" :key="'sn-'+i">{{e}}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :xxl="12" :xl="12" :lg="12" :md="24" :sm="24" :xs="24">
                <a-form-item :colon="false" label="过敏史" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                  <a-input v-decorator="['allergyHistory', {rules: [{ required: false }], initialValue: (record.allergy||'') }]" placeholder="请输入患者过敏史"/>
                </a-form-item>
              </a-col>
              <a-col :xxl="12" :xl="12" :lg="12" :md="24" :sm="24" :xs="24">
                <a-form-item :colon="false" label="治疗建议" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                  <a-input v-decorator="['suggest', {rules: [{ required: false }], initialValue: (record.suggest||'') }]" placeholder="请输入治疗建议"/>
                </a-form-item>
              </a-col>
            </a-row>
          </a-card>
          <a-card :bordered="false" size="small"
                  :head-style="{'borderBottom':'none', 'paddingLeft':'24px', 'paddingRight':'24px'}"
                  :body-style="{'padding':'0px'}">
            <span slot="title"
                  style="font-size: 18px;font-family: Alibaba PuHuiTi;font-weight: 500;color: #000000;">
              <img src="../../../assets/img/file.png"
                   style="width:17px;height:17px;margin-right: 9px;user-select: none;margin-top: -4px;"/>上传文件
            </span>
            <a-row>
              <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                <a-form-item label="症状图片" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
                  <a-upload list-type="picture-card" key="pics" accept="image/*"
                            :file-list="(telemed.pics||[]).filter(m => m.type == 'SYMPTOM')" @preview="handlePreview"
                            :remove="handleRemove" :before-upload="beforeUpload"
                            :custom-request="(src) => handleImgUpload(src, 'SYMPTOM')">
                    <div>
                      <div class="ant-upload-text"></div>
                      <a-icon type="plus"/>
                      <div class="ant-upload-text">
                        上传症状图片
                      </div>
                    </div>
                  </a-upload>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :xxl="12" :xl="12" :lg="12" :md="24" :sm="24" :xs="24">
                <a-form-item label="检查结果" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 20, xxl: 20 }">
                  <a-upload list-type="picture-card" key="pics" accept="image/*"
                            :file-list="(telemed.pics||[]).filter(m => m.type == 'CHECK_RESULT')"
                            @preview="handlePreview" :remove="handleRemove" :before-upload="beforeUpload"
                            :custom-request="(src) => handleImgUpload(src, 'CHECK_RESULT')">
                    <div>
                      <div class="ant-upload-text"></div>
                      <a-icon type="plus"/>
                      <div class="ant-upload-text">
                        上传检查结果图片
                      </div>
                    </div>
                  </a-upload>
                </a-form-item>
              </a-col>
              <a-col :xxl="12" :xl="12" :lg="12" :md="24" :sm="24" :xs="24">
                <a-form-item label="检验结果" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 20, xxl: 20 }">
                  <a-upload list-type="picture-card" key="pics" accept="image/*"
                            :file-list="(telemed.pics||[]).filter(m => m.type == 'INSPECT_RESULT')"
                            @preview="handlePreview" :remove="handleRemove" :before-upload="beforeUpload"
                            :custom-request="(src) => handleImgUpload(src, 'INSPECT_RESULT')">
                    <div>
                      <div class="ant-upload-text"></div>
                      <a-icon type="plus"/>
                      <div class="ant-upload-text">
                        上传检验结果图片
                      </div>
                    </div>
                  </a-upload>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :xxl="12" :xl="12" :lg="12" :md="24" :sm="24" :xs="24">
                <a-form-item label="病历资料" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 20, xxl: 20 }">
                  <a-upload list-type="picture-card" key="pics" accept="image/*"
                            :file-list="(telemed.pics||[]).filter(m => m.type == 'MEDICAL')" @preview="handlePreview"
                            :remove="handleRemove" :before-upload="beforeUpload"
                            :custom-request="(src) => handleImgUpload(src, 'MEDICAL')">
                    <div>
                      <div class="ant-upload-text"></div>
                      <a-icon type="plus"/>
                      <div class="ant-upload-text">
                        上传病历资料图片
                      </div>
                    </div>
                  </a-upload>
                </a-form-item>
              </a-col>
              <a-col :xxl="12" :xl="12" :lg="12" :md="24" :sm="24" :xs="24">
                <a-form-item label="体检报告" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }"
                             :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 20, xxl: 20 }">
                  <a-upload list-type="picture-card" key="pics" accept="image/*"
                            :file-list="(telemed.pics||[]).filter(m => m.type == 'PHYSICAL')" @preview="handlePreview"
                            :remove="handleRemove" :before-upload="beforeUpload"
                            :custom-request="(src) => handleImgUpload(src, 'PHYSICAL')">
                    <div>
                      <div class="ant-upload-text"></div>
                      <a-icon type="plus"/>
                      <div class="ant-upload-text">
                        上传体检报告图片
                      </div>
                    </div>
                  </a-upload>
                </a-form-item>
              </a-col>
            </a-row>
          </a-card>
        </a-form>
      </a-card>
      <a-card v-if="currstep == 2" :bordered="false" size="small"
              :head-style="{'borderBottom':'none', 'paddingLeft':'24px', 'paddingRight':'24px'}"
              :body-style="{'padding':'0px'}">
        <a-row>
          <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
            <a-form-item :colon="false" label="现病史" class="gpws-m-b-10 gpws-m-t-10"
                         :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                         :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              <a-textarea v-model="record.currHistory" placeholder="请输入现病史"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
            <a-form-item :colon="false" label="体格检查" style="margin-bottom: 0px;" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                         :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              <a-row>
                <a-col :xxl="5" :xl="5" :lg="5" :md="12" :sm="24" :xs="24">
                  <a-form-item :colon="false" label="脉搏" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                               :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                    <a-input-number :min="10" :max="180" :step="1" v-model="record.physical.pulse"
                                    placeholder="请输入脉搏"/>
                    次/分钟
                  </a-form-item>
                </a-col>
                <a-col :xxl="5" :xl="5" :lg="5" :md="12" :sm="24" :xs="24">
                  <a-form-item :colon="false" label="心率" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                               :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                    <a-input-number :min="10" :max="180" :step="1" v-model="record.physical.hr" placeholder="请输入心率"/>
                    次/分钟
                  </a-form-item>
                </a-col>
                <a-col :xxl="5" :xl="5" :lg="5" :md="12" :sm="24" :xs="24">
                  <a-form-item :colon="false" label="呼吸" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                               :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                    <a-input-number :min="10" :max="180" :step="1" v-model="record.physical.breath"
                                    placeholder="请输入呼吸"/>
                    次/分钟
                  </a-form-item>
                </a-col>
                <a-col :xxl="4" :xl="4" :lg="4" :md="12" :sm="24" :xs="24">
                  <a-form-item :colon="false" label="身高" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                               :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                    <a-input-number :min="10" :max="250" :step="1" v-model="record.physical.height"
                                    placeholder="请输入身高"/>
                    CM
                  </a-form-item>
                </a-col>
                <a-col :xxl="5" :xl="5" :lg="5" :md="12" :sm="24" :xs="24">
                  <a-form-item :colon="false" label="体重" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                               :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                    <a-input-number :min="1" :max="250" :step="0.1" v-model="record.physical.weight"
                                    placeholder="请输入体重"/>
                    KG
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
            <a-form-item :colon="false" label="辅助检查" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                         :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              <a-textarea v-model="record.auxiliary" placeholder="请输入辅助检查结果"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
            <a-form-item :colon="false" label="临床检验" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                         :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              <a-textarea v-model="record.laboratory" placeholder="请输入临床检验结果"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
            <a-form-item :colon="false" label="中医望闻问切" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                         :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              <a-textarea v-model="record.symptomDesc" placeholder="请输入中医望闻问切描述"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
            <a-form-item :colon="false" label="既往史" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                         :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              <a-textarea v-model="record.pastHistory" placeholder="请输入既往史"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
            <a-form-item :colon="false" label="个人史" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                         :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              <a-textarea v-model="record.selfHistory" placeholder="请输入个人史"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
            <a-form-item :colon="false" label="家族史" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                         :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              <a-textarea v-model="record.familyHistory" placeholder="请输入家族史"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
            <a-form-item :colon="false" label="其他病史" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                         :wrapper-col="{sm: 24, md: 12, lg: 21, xl: 21, xxl: 21 }">
              <a-textarea v-model="record.otherHistory" placeholder="请输入其他病史"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-card>
      <div style="position:fixed; left:0px; bottom:16px; width:100%; width: calc(95%); height: 26px; margin-top: 10px;">
        <div style="float: right;">
          <img src="../../../assets/img/t-r-v.png" v-if="currstep == 0"
               style="margin-right: 9px;cursor:pointer;user-select: none;" @click="telemedExportAction"/>
          <img src="../../../assets/img/t-r-s.png" v-if="(currstep == 1 || currstep == 2)"
               style="margin-right: 9px;cursor:pointer;user-select: none;" @click="telemedReserveAction"/>
          <img src="../../../assets/img/p.png" v-if="currstep == 1 || currstep == 2"
               style="margin-right: 9px;cursor:pointer;user-select: none;" @click="beforeAction"/>
          <img src="../../../assets/img/n.png" v-if="currstep == 1"
               style="margin-right: 9px;cursor:pointer;user-select: none;" @click="nextAction"/>
          <img src="../../../assets/img/close.png" style="cursor:pointer;user-select: none;" @click="onDrawerClose"/>
        </div>
      </div>
      <a-modal :visible="init.previewVisible" :footer="null" @cancel="handleCancel">
        <img style="width: 100%" :src="init.previewImage"/>
      </a-modal>
    </a-spin>
    <a-modal :title="null" :centered="true" style="z-index: 999999;" :mask-closable="false" :closable="false"
             :visible="qrcode.visible" :footer="null" :body-style="{'padding':'0px', 'borderRadius':'4px'}"
             :width="320">
      <a-row>
        <a-col style="height: 40px;line-height: 40px;text-align: center;">您本次需支付金额为:<span
            style="color: #D02F2F;font-size: 18px;font-weight: 500;">¥&nbsp;{{ qrcode.amount.toFixed(2) }}</span>,请扫码支付.
        </a-col>
      </a-row>
      <a-row>
        <a-col style="text-align: center;"><img :src="qrcode.qrcode" width="256" height="256"
                                                style="padding: 24px;user-select: none;"/></a-col>
      </a-row>
      <a-row>
        <a-col style="text-align: center;padding: 24px;">
          <img src="../../../assets/img/close.png" style="cursor:pointer;user-select: none;"
               @click="qrcodeCancelAction"/>
        </a-col>
      </a-row>
    </a-modal>
  </a-drawer>
</template>

<script>
import {Icon} from 'ant-design-vue';
import global from "../../../api/global";
import moment from "moment";
import doctorAvater from '@/assets/img/doctor-avater.png';

const IconFont = Icon.createFromIconfontCN({
  scriptUrl: global.scriptUrl,
});
export default {
  name: "TelemedDrawer",
  components: {
    IconFont
  },
  data() {
    return {
      visible: false,
      loading: false,
      timeHandler:undefined,
      currstep: 0,
      current: {},
      doctorAvater: doctorAvater,
      loadTip: '正在预约远程辅诊服务....',
      experts: [],//专家列表
      schedules: [],//排班列表
      scheduleDate: null,
      intervals: [],//时段列表
      feeMoney: 0.0,
      feed: false,//是否已读取到收费标准
      mavinOrganId:'', //当前选择远程专家的执业机构ID
      doctorId: '',
      paymethods: [],
      record: {visitType: 'INITIAL_VISIT', city: '', county: ''},
      diseased:undefined,
      telemed: {
        gestate: false,
        diseases: [],
        pics: [],
        form: this.$form.createForm(this)
      },
      history:{
        datas:[],
        opened:false,
        columns:[{title: '就诊日期', key: 'visitdate', align: 'center', width: 100, customRender:(text, record, index) =>{
            return record.date+' '+record.time;
          }},
          {title: '手机号码', key: 'phone', align: 'center', width: 120, customRender:(text, record, index) =>{
              return record.phone;
            }},
          {title: '临床诊断', key: 'diagnostic', customRender:(text, record, index) =>{
              return record.diagnostic;
            }}]
      },
      init: {
        currentYear: '',
        currentMonth: '',
        diseases: [],
        symptoms: [],
        syndromes: [],
        marriages: [],
        provinces: [],
        citys: [],
        countys: [],
        previewImage: '',
        previewVisible: false
      },
      qrcode:{
        interval:undefined,
        visible:false,
        amount:0.0,
        orderId:'',
        qrcode:''
      }
    }
  },
  mounted() {
    this.current = JSON.parse(localStorage.getItem("curruser"));
  },
  beforeDestroy() {
    if(undefined != this.qrcode.interval && this.qrcode.interval != null){
      window.clearInterval(this.qrcode.interval);
    }
  },
  methods: {
    loadHistoryOutpatients:function () {
      if(undefined != this.timeHandler || null != this.timeHandler){
        window.clearTimeout(this.timeHandler);
      }
      this.timeHandler = window.setTimeout(this.historyOutpatients, 1500);
    },
    historyOutpatients:function (){
      const self = this;
      this.history.datas = [];
      this.history.opened = false;
      let name = this.telemed.form.getFieldValue('name');
      if(undefined != name && null != name && '' != name ){
        if(this.record.visitType == 'SUBSEQUENT_VISIT'){
          this.loadTip='正在加载检索历史门诊信息,请稍候....';
          this.loading=true;
          this.$axios.get('/api/clinic/' + this.current.organId + '/history/outpatients', {params:{name:name, treatType:'TELEMEDICINE'}}).then(function(res){
            self.loading=false;
            if(res.msg.flag == 0 && null != res.biz){
              self.history.datas = res.biz;
              self.history.opened = true;
            }
          },function(){
            self.loading=false;
          });
        }
      }
    },
    historyCustomRow:function (record, index){
      return {
        style:{
          cursor: 'pointer'
        },
        on: {
          click: (event) => this.loadHistory(event, record.id)
        }
      };
    },
    loadHistory:function (event, id) {
      const self= this;
      this.loadTip='正在加载初诊信息,请稍候....';
      this.loading=true;
      this.$axios.get('/api/clinic/local/outpatient/'+id).then(function (res) {
        self.loading=false;
        self.onCloseHistory();
        if (res.msg.flag == 0){
          if(undefined != res.biz && null != res.biz){
            self.record = Object.assign(self.record, {visitId:res.biz.id, memberId : res.biz.patient.oid,
              name: res.biz.patient.name, sex: res.biz.patient.sex, year: (res.biz.patient.year||{age:0}).age,
              month: (res.biz.patient.month||{age:0}).age, idcard: res.biz.patient.idcard, phone: res.biz.patient.phone,
              gestate:res.biz.gestate, complaint:res.biz.complaint, marriage: res.biz.patient.marriage, allergy:res.biz.allergy});
            if (undefined != self.record.sex && null != self.record.sex && undefined != self.record.year && null != self.record.year) {
              if (parseInt(self.record.year) >= 15 && parseInt(self.record.year) < 50 && self.record.sex == 'FEMALE') {
                self.telemed.gestate = true;
              } else if(parseInt(self.record.year) == 50 && (self.record.month||0) <= 0 && self.record.sex == 'FEMALE'){
                self.telemed.gestate = true;
              } else {
                self.telemed.gestate = false;
              }
            } else {
              self.telemed.gestate = false;
            }
            if(undefined != res.biz.patient.address && null != res.biz.patient.address){
              if(undefined != res.biz.patient.address.district && null != res.biz.patient.address.district){
                self.loadDistrict(res.biz.patient.address.district);
              }
              self.record.address = res.biz.patient.address.address||'';
            }
            if(undefined != res.biz.diagnostic && null != res.biz.diagnostic){
              if(undefined != res.biz.diagnostic.diseases && null != res.biz.diagnostic.diseases && res.biz.diagnostic.diseases.length > 0){
                res.biz.diagnostic.diseases.forEach(function (e) {
                  self.init.diseases.push({id:e.oid, name:e.name});
                });
                self.record.diseases = res.biz.diagnostic.diseases.map(m => m.oid);
              }
              if(undefined != res.biz.diagnostic.symptom && null != res.biz.diagnostic.symptom){
                self.init.symptoms.push({id:res.biz.diagnostic.symptom.oid, name:res.biz.diagnostic.symptom.name});
                self.record.symptom = res.biz.diagnostic.symptom.oid;
              }
              self.record.syndromes = res.biz.diagnostic.syndromes;
              self.init.syndromes = res.biz.diagnostic.syndromes;
              self.record.suggest = res.biz.diagnostic.suggest;
            }
            self.onBlurIdcard();
            self.$forceUpdate();
          }
        }else{
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }, function (res) {
        self.loading=false;
      });
    },
    onCloseHistory:function (){
      this.history.opened = false;
    },
    readIdcard:function (){
      const self = this;
      let request = undefined;
      if (window.XMLHttpRequest){
        request = new XMLHttpRequest();
      }else{
        request = new ActiveXObject("Microsoft.XMLHTTP");
      }

      request.open('GET', 'http://127.0.0.1:12533/read/', true);
      request.onreadystatechange = function () {
        if(request.readyState == 4){
          if(request.status==200){
            let result = request.responseText;
            if(undefined == result || null == result || '' == result){
              self.$message.error({content: '身份证读取返回为空.', duration: 2});
              return;
            }
            let idcard = JSON.parse(result);
            if(idcard.rtn == 0 && undefined != idcard.biz && null != idcard.biz){
              let district = idcard.biz.id.substr(0, 6);

              self.$axios.get('/api/dmz/district/' + district).then(function (res) {
                if (res.msg.flag == 0 && undefined != res.biz && null != res.biz) {
                  self.loadDistrict(res.biz);
                  self.record.address = idcard.biz.address.substr(idcard.biz.address.indexOf(res.biz.name)+1);
                }
              }, function (res) {
              });
              self.record.address = idcard.biz.address;
              self.telemed.form.setFieldsValue({'name': idcard.biz.name, 'sex': ((idcard.biz.gender =='男')?'MALE':'FEMALE'),
                'idcard':idcard.biz.id });
              self.onBlurIdcard();
            }else{
              self.$message.error({content: idcard.msg, duration: 2});
              return;
            }
          }
          if(request.status == 0){
            self.$message.error({content: '身份证读取程序未启动.', duration: 2});
          }
        }
      };
      request.send();
    },
    showTelemedDrawer: function (record) {
      const self = this;
      this.currstep = 0;
      this.init.currentYear=new Date().getFullYear();
      this.init.currentMonth = new Date().getMonth() + 1;
      this.scheduleDate = this.getCurrDate(new Date());
      this.loadExperts();//加载本月远程专家
      this.record = record;
      this.record.gestate = ((record.gestate||false) === true);

      if (undefined != record.sex && null != record.sex && undefined != record.year && null != record.year) {
        if (parseInt(record.year) >= 15 && parseInt(record.year) < 50 && record.sex == 'FEMALE') {
          this.telemed.gestate = true;
        } else if(parseInt(record.year) == 50 && (record.month||0) <= 0 && record.sex == 'FEMALE'){
          this.telemed.gestate = true;
        } else {
          this.telemed.gestate = false;
        }
      } else {
        this.telemed.gestate = false;
      }
      if(undefined != record.diseases && null != record.diseases && record.diseases.length > 0){
        this.diseased = true;
      }
      if(undefined != record.symptom && null != record.symptom && '' != record.symptom){
        this.diseased = false;
      }
      if(undefined != record.district && null != record.district){
        if(undefined != record.district.district && null != record.district.district){
          this.loadDistrict(record.district.district);
        }
        this.record.address = record.district.address||'';
      }
      if(undefined != this.record.init && null != this.record.init){
        this.init.syndromes = this.record.init.syndromes||[];
        this.init.symptoms = this.record.init.symptoms||[];
        this.init.diseases = this.record.init.diseases||[];
      }
      this.visible = true;

      this.getMarriages(function (res) {
        self.init.marriages = res;
      });

      if (localStorage.getItem("provinces")) {
        this.init.provinces = JSON.parse(localStorage.getItem("provinces"));
      } else {
        this.getProvinces({params: {parentCode: '', level: 'PROVINCE'}}, function (res) {
          let provinces = [];
          provinces.push({id: '', name: '--请选择--'});
          res.forEach(function (item) {
            provinces.push({id: item.id, name: item.name});
          });
          localStorage.setItem("provinces", JSON.stringify(provinces));
          self.init.provinces = provinces;
        });
      }
    },
    //选择日期后预约
    telemedExportAction: function () {
      const self = this;
      if (undefined == this.doctorId || null == this.doctorId || '' == this.doctorId) {
        this.$message.error({content: '请先选择远程辅诊专家.', duration: 2});
        return;
      }

      let schedules = (this.schedules || []).filter(m => m.scheduleDate == this.scheduleDate);
      if (schedules.length <= 0) {
        this.$message.error({content: '所选日期专家无排班信息.', duration: 2});
        return;
      }
      if (schedules[0].reserveNumber <= 0) {
        this.$message.error({content: '所选日期专家预约已满.', duration: 2});
        return;
      }
      if (!this.feed) {
        this.$message.error({content: '专家对应职称的远程收费标准未设置.', duration: 2});
        return;
      }
      this.loadScheduleIntervals();
      this.getPaymentMethods(this.current.organId, 'PLATFORM', {params:{doctorId:this.doctorId}}, function (res) {
        self.paymethods = res;
      });
      this.currstep = 1;
    },
    nextAction: function () {
      const self = this;
      this.telemed.form.validateFields((err, values) => {
        if (!err) {
          if('true' == values.gestate){
            if('FEMALE' != values.sex){
              self.$message.error({content: '孕否选择有误.', duration: 1});
              return;
            }
            if(undefined == values.year || null == values.year || '' == values.year){
              self.$message.error({content: '孕否选择有误.', duration: 1});
              return;
            }
            if(parseInt(values.year)< 15 || parseInt(values.year) > 50){
              self.$message.error({content: '孕否选择有误.', duration: 1});
              return;
            }
            if(parseInt(values.year) == 50 && self.record.month > 0){
              self.$message.error({content: '孕否选择有误.', duration: 1});
              return;
            }
          }

          let districtId = '', fullAddress = '';
          if (undefined != self.record.county && null != self.record.county && '' != self.record.county) {
            districtId = self.record.county;
            self.init.countys.forEach(function (e) {
              if (e.id == self.record.county) {
                fullAddress = e.name + fullAddress;
              }
            });
            self.init.citys.forEach(function (e) {
              if (e.id == self.record.city) {
                fullAddress = e.name + fullAddress;
              }
            });
            self.init.provinces.forEach(function (e) {
              if (e.id == self.record.province) {
                fullAddress = e.name + fullAddress;
              }
            });
          } else if (undefined != self.record.city && null != self.record.city && '' != self.record.city) {
            districtId = self.record.city;
            self.init.citys.forEach(function (e) {
              if (e.id == self.record.city) {
                fullAddress = e.name + fullAddress;
              }
            });
            self.init.provinces.forEach(function (e) {
              if (e.id == self.record.province) {
                fullAddress = e.name + fullAddress;
              }
            });
          } else {
            districtId = self.record.province;
            self.init.provinces.forEach(function (e) {
              if (e.id == self.record.province) {
                fullAddress = e.name + fullAddress;
              }
            });
          }
          fullAddress = fullAddress + self.record.address;

          self.record = {
            id: ((undefined != self.record && null != self.record && undefined != self.record.id
                && null != self.record.id && '' != self.record.id) ? self.record.id : ''),
            scheduleId: values.scheduleId,
            visitType: self.record.visitType,
            visitId:self.record.visitId,
            allergyHistory:values.allergyHistory,
            name: values.name,
            sex: values.sex,
            payMethod: values.payMethod,
            year: values.year,
            month: self.record.month,
            idcard: values.idcard,
            gestate: values.gestate,
            phone: values.phone,
            marriage: values.marriage,
            complaint: values.complaint,
            fullAddress: fullAddress,
            physical: {temperature: values.temperature, sbp: self.record.sbp, dbp: self.record.dbp, glu: values.glu},
            diseases: values.diseases,
            symptom:values.symptom,
            syndromes: values.syndromes,
            suggest: values.suggest,
            doctorId: self.doctorId,
            mavinOrganId : self.mavinOrganId,
            districtId: districtId,
            address: self.record.address,
            pics: (self.telemed.pics || []).filter(m => m.type == 'SYMPTOM').map(m => m.path),
            annexes: (self.telemed.pics || []).filter(m => m.type != 'SYMPTOM').map(m => {
              return {type: m.type, pic: m.path};
            })
          };

          self.currstep = 2;
        }
      });
    },
    beforeAction: function () {
      if (this.currstep > 0) {
        this.currstep--;
      } else {
        this.currstep = 0;
      }
    },
    telemedReserveAction: function () {
      const self = this;

      if(this.record.visitType == 'SUBSEQUENT_VISIT' && (this.record.visitId||'') == ''){
        this.$message.error({content: '请先选择本次复诊对应的初诊门诊信息.', duration: 1});
        return;
      }

      if (this.currstep == 1) {
        this.telemed.form.validateFields((err, values) => {
          if (!err) {
            if('true' == values.gestate){
              if('FEMALE' != values.sex){
                self.$message.error({content: '孕否选择有误.', duration: 1});
                return;
              }
              if(undefined == values.year || null == values.year || '' == values.year){
                self.$message.error({content: '孕否选择有误.', duration: 1});
                return;
              }
              if(parseInt(values.year)< 15 || parseInt(values.year) > 50){
                self.$message.error({content: '孕否选择有误.', duration: 1});
                return;
              }
              if(parseInt(values.year) == 50 && self.record.month > 0){
                self.$message.error({content: '孕否选择有误.', duration: 1});
                return;
              }
            }

            let districtId = '', fullAddress = '';
            if (undefined != self.record.county && null != self.record.county && '' != self.record.county) {
              districtId = self.record.county;
              self.init.countys.forEach(function (e) {
                if (e.id == self.record.county) {
                  fullAddress = e.name + fullAddress;
                }
              });
              self.init.citys.forEach(function (e) {
                if (e.id == self.record.city) {
                  fullAddress = e.name + fullAddress;
                }
              });
              self.init.provinces.forEach(function (e) {
                if (e.id == self.record.city) {
                  fullAddress = e.name + fullAddress;
                }
              });
            } else if (undefined != self.record.city && null != self.record.city && '' != self.record.city) {
              districtId = self.record.city;
              self.init.citys.forEach(function (e) {
                if (e.id == self.record.city) {
                  fullAddress = e.name + fullAddress;
                }
              });
              self.init.provinces.forEach(function (e) {
                if (e.id == self.record.province) {
                  fullAddress = e.name + fullAddress;
                }
              });
            } else {
              districtId = self.record.province;
              self.init.provinces.forEach(function (e) {
                if (e.id == self.record.province) {
                  fullAddress = e.name + fullAddress;
                }
              });
            }
            fullAddress = fullAddress + self.record.address;

            let params = {
              id: ((undefined != self.record && null != self.record && undefined != self.record.id
                  && null != self.record.id && '' != self.record.id) ? self.record.id : ''),
              scheduleId: values.scheduleId,
              visitType: self.record.visitType,
              visitId:self.record.visitId,
              registerId:self.record.registerId,
              allergyHistory:values.allergyHistory,
              name: values.name,
              sex: values.sex,
              payMethod: values.payMethod,
              year: values.year,
              month: self.record.month,
              idcard: values.idcard,
              gestate: values.gestate,
              phone: values.phone,
              marriage: values.marriage,
              complaint: values.complaint,
              fullAddress: fullAddress,
              physical: {temperature: values.temperature, sbp: self.record.sbp, dbp: self.record.dbp, glu: values.glu},
              diseases: values.diseases,
              symptom:values.symptom,
              syndromes: values.syndromes,
              suggest: values.suggest,
              doctorId: self.doctorId,
              mavinOrganId : self.mavinOrganId,
              districtId: districtId,
              address: self.record.address,
              pics: (self.telemed.pics || []).filter(m => m.type == 'SYMPTOM').map(m => m.path),
              annexes: (self.telemed.pics || []).filter(m => m.type != 'SYMPTOM').map(m => {
                return {type: m.type, pic: m.path};
              })
            };
            self.loading = true;
            self.loadTip = '正在保存远程辅诊预约信息,请稍候...';
            self.$axios.post('/api/clinic/' + self.current.organId + '/telemed/reserve', params).then(function (res) {
              self.loading = false;
              if (res.msg.flag == 0) {
                if (undefined != res.biz && null != res.biz) {
                  if (res.biz.paid) {
                    self.$message.success({content: '远程辅诊预约成功.', duration: 2});
                    self.$emit('clickit');
                    self.onDrawerClose();
                  } else {
                    //弹出扫码框
                    self.qrcode = Object.assign({visible : true},
                        {amount:res.biz.amount, orderId:res.biz.orderId, qrcode:'data:image/jpeg;base64,'+res.biz.qrcode});
                    self.qrcode.interval = window.setInterval(self.paymentResultAction, 2000);
                  }
                } else {
                  self.$message.error({content: res.msg.message, duration: 2});
                }
              } else {
                self.$message.error({content: res.msg.message, duration: 2});
              }
            }, function (res) {
              self.loading = false;
            });
          }
        });
      } else {
        let params = Object.assign(this.record, {registerId:self.record.registerId,visitId:self.record.visitId,
          visitType:self.record.visitType, doctorId: this.doctorId});
        this.loading = true;
        this.loadTip = '正在保存远程辅诊预约信息,请稍候...';
        this.$axios.post('/api/clinic/' + this.current.organId + '/telemed/reserve', params).then(function (res) {
          self.loading = false;
          if (res.msg.flag == 0) {
            if (undefined != res.biz && null != res.biz) {
              if (res.biz.paid) {
                self.$message.success({content: '远程辅诊预约成功.', duration: 2});
                self.$emit('clickit');
                self.onDrawerClose();
              } else {
                //弹出扫码框
                self.qrcode = Object.assign({visible : true},
                    {amount:res.biz.amount, orderId:res.biz.orderId, qrcode:'data:image/jpeg;base64,'+res.biz.qrcode});
                self.qrcode.interval = window.setInterval(self.paymentResultAction, 2000);
              }
            } else {
              self.$message.error({content: res.msg.message, duration: 2});
            }
          } else {
            self.$message.error({content: res.msg.message, duration: 2});
          }
        }, function (res) {
          self.loading = false;
        });
      }
    },
    paymentResultAction:function () {
      const self = this;
      this.$axios.get('/api/clinic/order/' + this.qrcode.orderId + '/payresult').then(function (res) {
        if (res.msg.flag == 0) {
          window.clearInterval(self.qrcode.interval);
          self.$message.success({content:'远程辅诊支付成功', duration:2 })
          setTimeout(function () {
            self.qrcodeCancelAction();
          },2000)

        }
      }, function (res) {
      });
    },
    qrcodeCancelAction: function () {
      if(undefined != this.qrcode.interval && this.qrcode.interval != null){
        window.clearInterval(this.qrcode.interval);
      }
      this.qrcode = { interval:undefined, visible:false, amount:0.0, orderId:'', qrcode:''};
      this.onDrawerClose();
      this.$emit('clickit');
    },
    scheduleDateSelect: function (value) {
      let schedules = this.schedules.filter(m => m.scheduleDate == value.format('YYYY-MM-DD'));
      if (schedules.length <= 0) {
        this.$message.info({content: '所选日期无专家排班信息.', duration: 2});
        return;
      }
      if (schedules[0].reserveNumber <= 0) {
        this.$message.info({content: '所选日期专家预约已满.', duration: 2});
        return;
      }
      this.scheduleDate = value.format('YYYY-MM-DD');
    },
    getScheduleDate: function (value) {
      if (value && value < moment().subtract(1, 'days').endOf('day')) {
        return null;
      }
      if (undefined == this.schedules || null == this.schedules || this.schedules.length <= 0) {
        return null;
      }
      let schedules = this.schedules.filter(m => m.scheduleDate == value.format('YYYY-MM-DD'));
      if (schedules.length > 0) {
        return schedules[0];
      }
      return null;
    },
    onPanelChange: function (value) {
      this.init.currentYear = value.year();
      this.init.currentMonth = value.month() + 1;
    },
    disabledDate: function (current) {
      return current && current < moment().subtract(1, 'days').endOf('day');
    },
    loadScheduleIntervals: function () {
      const self = this;
      this.intervals = [];
      this.$axios.get('/api/clinic/schedule/' + this.doctorId + '/' + this.scheduleDate, {params: {organId:this.mavinOrganId, business: 'TELEMEDICINE'}}).then(function (res) {
        if (res.msg.flag == 0 && null != res.biz && res.biz.length > 0) {
          self.intervals = res.biz;
        }
      }, function (res) {
      });
    },
    loadExperts: function () {
      const self = this;
      this.doctorId = '';
      this.experts = [];
      this.loadTip = '正在获取远程诊疗专家信息.';
      this.loading = true;
      this.$axios.get('/api/clinic/schedule/experts', {
        params: {
          scheduleYear: this.init.currentYear,
          scheduleMonth: this.init.currentMonth
        }
      }).then(function (res) {
        self.loading = false;
        if (res.msg.flag == 0 && null != res.biz && res.biz.length > 0) {
          self.experts = res.biz;
        }
      }, function (res) {
        self.loading = false;
      });
    },
    onExpertChange: function (organId, id) {
      this.doctorId = id;
      this.mavinOrganId = organId;
      this.loadMonthSchedules();
      this.loadRemoteFee();
    },
    loadMonthSchedules: function () {
      const self = this;
      this.schedules = [];
      this.loadTip = '正在获取远程诊疗专家排班信息.';
      this.loading = true;
      if (undefined != this.doctorId && null != this.doctorId && '' != this.doctorId) {

        console.info('开始查询...')
        console.info(this.organId)
        this.$axios.get('/api/clinic/'+this.mavinOrganId+'/doctor/' + this.doctorId + '/schedules').then(function (res) {
          self.loading = false;
          if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            self.schedules = res.biz;
          }
        }, function (res) {
          self.loading = false;
        });
      }
    },
    //获取医生远程诊疗费用
    loadRemoteFee: function () {
      const self = this;
      this.feed = false;
      if (undefined != this.doctorId && null != this.doctorId && '' != this.doctorId) {
        this.$axios.get('/api/clinic/'+this.mavinOrganId+'/doctor/' + this.doctorId + '/telemed/fee').then(function (res) {
          if (res.msg.flag == 0) {
            if (undefined != res.biz && null != res.biz) {
              self.feed = true;
              self.feeMoney = res.biz;
            }
          } else {
            self.$message.error({content: res.msg.message, duration: 2});
          }
        }, function (res) {
        });
      }
    },
    onDrawerClose: function () {
      this.visitDate = '';
      this.doctorId = '';
      this.scheduleId = '';
      this.intervals = [];
      this.experts = [];
      this.feed = false;
      this.init.symptoms = [];
      this.feeMoney = 0.0;
      if(undefined != this.qrcode.interval && this.qrcode.interval != null){
        window.clearInterval(this.qrcode.interval);
      }
      this.visible = false;
    },
    loadDistrict:function(district){
      if(undefined != district && null != district){
        if(district.level == 'PROVINCE'){
          this.record.province = district.oid;
          this.loadCitys(this.record.province);
        }else{
          if(undefined != district.ancestors && null != district.ancestors && district.ancestors.length > 0){
            this.record.province = district.ancestors[0];
            this.loadCitys(this.record.province);
            if(district.level == 'CITY'){
              this.record.city = district.oid;
              this.loadCountys(this.record.city);
            }else{
              if(district.ancestors.length > 1){
                this.record.city = district.ancestors[1];
                this.loadCountys(this.record.city);
                this.record.county = district.oid;
              }
            }
          }
        }
      }
    },
    loadCitys: function (value) {
      const self = this;
      this.record.city = '';
      this.record.county = '';
      this.init.citys = [];
      this.init.citys.push({id: '', name: '--请选择--'});
      if (null != value && '' != value) {
        this.$axios.get('/api/dmz/district/childrens', {
          params: {
            parentCode: value,
            level: 'CITY'
          }
        }).then(function (res) {
          if (res.msg.flag == 0) {
            if (null != res.biz && !res.biz.empty) {
              res.biz.forEach(function (item, index) {
                self.init.citys.push({id: item.id, name: item.name});
              });
            }
          }
        }, function (res) {
        });
      }
    },
    getCounty:function (value){
      this.record.county = value;
      this.$forceUpdate();
    },
    loadCountys: function (value) {
      const self = this;
      this.record.county = '';
      this.init.countys = [];
      this.init.countys.push({id: '', name: '--请选择--'});
      if (null != value && '' != value) {
        this.$axios.get('/api/dmz/district/childrens', {
          params: {
            parentCode: value,
            level: 'COUNTY'
          }
        }).then(function (res) {
          if (res.msg.flag == 0) {
            if (null != res.biz && !res.biz.empty) {
              res.biz.forEach(function (item, index) {
                self.init.countys.push({id: item.id, name: item.name});
              });
            }
          }
        }, function (res) {
        });
      }
    },
    handleDiseaseFocus: function () {
      this.init.diseases = [];
    },
    handleDiseaseSelect: function (value) {
      const self = this;
      this.init.diseases.forEach(function (e, m) {
        if (e.id == value && self.telemed.diseases.filter(n => n.id == e.id).length <= 0) {
          self.telemed.diseases.push(e);
        }
      });
      this.diseased = true;
      this.loadSyndromes();
    },
    handleDiseaseCancel: function (value) {
      const self = this;
      let data = new Array();
      let deleteIndex = -1;
      Object.assign(data, this.telemed.diseases);
      this.telemed.diseases.forEach(function (e, m) {
        if (e.id == value) {
          deleteIndex = m;
        }
      });
      if (deleteIndex >= 0) {
        data.splice(deleteIndex, 1);
      }
      this.telemed.diseases = data;
      if((this.telemed.diseases||[]).length <= 0){
        this.diseased = undefined;
      }else{
        this.diseased = true;
      }
      this.loadSyndromes();
    },
    loadSyndromes: function () {
      const self = this;
      this.init.syndromes = [];

      this.telemed.diseases.forEach(function (e, i) {
        if (undefined != e.syndromes && null != e.syndromes && e.syndromes.length > 0) {
          e.syndromes.forEach(function (m, n) {
            if (self.init.syndromes.filter(a => a == m.name).length <= 0) {
              self.init.syndromes.push(m.name);
            }
          });
        }
      });
    },
    //疾病查询
    handleDiseaseSearch: function (value) {
      if(undefined != this.timeHandler || null != this.timeHandler){
        window.clearTimeout(this.timeHandler);
      }
      this.timeHandler = window.setTimeout(this.diseaseSearch, 1000, value);
    },
    diseaseSearch: function (value) {
      const self = this;
      this.init.diseases = [];

      let sex = this.telemed.form.getFieldValue('sex');
      let year = this.telemed.form.getFieldValue('year');

      if (undefined != value && null != value && '' != value && value.length > 1) {
        this.$axios.get('/api/clinic/diseases', {
          params: {
            keyword: value, sex: sex,
            year: year, month: self.record.month
          }
        }).then(function (res) {
          if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            self.init.diseases = res.biz;
          }
        }, function (res) {
        });
      }
    },
    mainSymptomSearch: function (value) {
      if(undefined != this.timeHandler || null != this.timeHandler){
        window.clearTimeout(this.timeHandler);
      }
      this.timeHandler = window.setTimeout(this.symptomSearch, 1000, value);
    },
    symptomSearch:function (value) {
      const self = this;
      let sex = this.telemed.form.getFieldValue('sex');
      let year = this.telemed.form.getFieldValue('year');

      let months = ((year || 0) * 12) + this.record.month;

      this.init.symptoms = [];
      if (undefined != value && null != value && '' != value && value.trim().length > 0) {
        this.$axios.get('/api/clinic/position/symptoms', {
          params: { keyword: value, sex: sex, months: months, common:true }
        }).then(function (res) {
          self.init.symptoms = [];
          if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            res.biz.forEach(function (e) {
              if (undefined != e.children && null != e.children && e.children.length > 0) {
                e.children.forEach(function (m) {
                  self.init.symptoms.push(m);
                });
              }
            });
          }
        }, function (res) {
        });
      }
    },
    mainSymptomSelect:function (value) {
      const self = this;
      this.init.syndromes=[];
      if(undefined != value && null != value && '' != value){
        this.$axios.get('/api/clinic/symptom/' + value + '/syndromes').then(function (res) {
          res.biz.forEach(function(e){
            self.init.syndromes.push(e.value);
          });
        }, function (res) {
        });
        this.diseased = false;
      }else{
        this.diseased = undefined;
      }
    },
    gestateSexChange: function (value) {
      let age = this.telemed.form.getFieldValue('year');

      if (undefined != value && null != value && '' != value && undefined != age && null != age) {
        if (parseInt(age) >= 15 && parseInt(age) < 50 && value == 'FEMALE') {
          this.telemed.gestate = true;
        } else if(parseInt(age) == 50 && this.record.month <=0 && value == 'FEMALE'){
          this.telemed.gestate = true;
        } else {
          this.telemed.gestate = false;
          this.telemed.form.setFieldsValue({'gestate': 'false'});
        }
      } else {
        this.telemed.gestate = false;
        this.telemed.form.setFieldsValue({'gestate': 'false'});
      }
    },
    gestateAgeMonthChange:function (){
      let sex = this.telemed.form.getFieldValue('sex');
      let age = this.telemed.form.getFieldValue('year');

      if (undefined != sex && null != sex && '' != sex && undefined != age && null != age) {
        if (parseInt(age) >= 15 && parseInt(age) < 50 && sex == 'FEMALE') {
          this.telemed.gestate = true;
        } else if(parseInt(age) == 50 && this.record.month <= 0 && sex == 'FEMALE'){
          this.telemed.gestate = true;
        } else {
          this.telemed.gestate = false;
          this.telemed.form.setFieldsValue({'gestate': 'false'});
        }
      } else {
        this.telemed.gestate = false;
        this.telemed.form.setFieldsValue({'gestate': 'false'});
      }
    },
    gestateAgeChange: function (value) {
      let sex = this.telemed.form.getFieldValue('sex');

      if (undefined != sex && null != sex && '' != sex && undefined != value && null != value) {
        if (parseInt(value) >= 15 && parseInt(value) < 50 && sex == 'FEMALE') {
          this.telemed.gestate = true;
        } else if(parseInt(value) == 50 && this.record.month <=0 && sex == 'FEMALE'){
          this.telemed.gestate = true;
        } else {
          this.telemed.gestate = false;
          this.telemed.form.setFieldsValue({'gestate': 'false'});
        }
      } else {
        this.telemed.gestate = false;
        this.telemed.form.setFieldsValue({'gestate': 'false'});
      }
    },
    beforeUpload: function (file) {
      const self = this;

      const isLt = file.size / 1024 / 1024 < 1;
      if (!isLt) {
        self.$message.error({content: '图片文件大小需少于1M.', duration: 2});
        return false;
      }
      return true;
    },
    handleImgUpload: function (src, type) {
      const self = this;
      const isLt = src.file.size / 1024 / 1024 < 1;
      if (!isLt) {
        self.$message.error({content: '图片文件大小少于1M.', duration: 2});
        return false;
      }
      let params = new FormData();
      params.append("file", src.file);
      this.loadTip = '正在上传文件....';
      this.loading = true;
      this.$axios.post('/api/dmz/MEDICAL/file/upload', params, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }, timeout: 1000 * 60 * 15
      }).then(function (res) {
        self.loading = false;
        if (res.msg.flag == 0) {
          self.telemed.pics.push({
            uid: 'pic-' + (self.telemed.pics.length + 1), type: type, name: 'pic-' + (self.telemed.pics.length + 1),
            status: 'done', path: res.biz.path, url: res.biz.url
          });
        } else {
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }, function () {
        self.loading = false;
      });

      return false;
    },
    handleRemove: function (src) {
      const self = this;
      this.$axios.delete('/api/dmz/file/remove', {params: {path: src.path}}).then(function (res) {
        if (res.msg.flag == 0) {
          let data = new Array();
          let deleteIndex = 0;
          Object.assign(data, self.telemed.pics);
          self.telemed.pics.forEach(function (e, m) {
            if (e.uid == src.uid) {
              deleteIndex = m;
            }
          });
          data.splice(deleteIndex, 1);
          self.telemed.pics = data;
        } else {
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }, function () {
      });
    },
    handlePreview: function (file) {
      if (!file.url && !file.preview) {
        file.preview = this.getBase64(file.originFileObj);
      }
      this.init.previewImage = file.url || file.preview;
      this.init.previewVisible = true;
    },
    getBase64: function (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    handleCancel() {
      this.init.previewVisible = false;
    },
    onBlurIdcard:function (){
      let idcard = this.telemed.form.getFieldValue('idcard');
      if(undefined != idcard && null != idcard && '' != idcard && (idcard.length == 18 || idcard.length == 15)){
        idcard = idcard.trim();
        let birthday = '';
        let sex='';
        if (idcard.length == 18){
          birthday = idcard.substr(6, 4) + "/" + idcard.substr(10, 2) + "/" + idcard.substr(12, 2);
          if(parseInt(idcard.charAt(16))%2 == 0){
            sex ='FEMALE';
          }else{
            sex ='MALE';
          }
        }
        if (idcard.length == 15) {
          birthday = "19" + idcard.substr(6, 2) + "/" + idcard.substr(8, 2) + "/" + idcard.substr(10, 2);
          if(parseInt(idcard.charAt(14))%2 == 0){
            sex ='FEMALE';
          }else{
            sex ='MALE';
          }
        }
        let birthDate = new Date(birthday);
        let nowDateTime = new Date();
        let age = nowDateTime.getFullYear() - birthDate.getFullYear();

        this.telemed.form.setFieldsValue({'year':age, 'sex':sex});
        this.gestateAgeMonthChange();
      }
    }
  }
}
</script>

<style scoped>
.gpws-m-b-12 {
  margin-bottom: 12px !important;
}

.gpws-schedule-reserve-span {
  border-left: 4px solid rgba(95, 192, 33, 1);
  width: 60px;
  height: 18px;
  line-height: 18px;
  background: #E8F6DF;
  border-radius: 4px;
  font-size: 13px;
  font-family: Alibaba PuHuiTi;
  font-weight: 400;
  color: #5FC021;
}

.gpws-schedule-reserve-span-selected {
  background: rgba(252, 240, 240, 0.2);
  color: #ffffff;
  border-left: 4px solid rgba(255, 255, 255, 1);
}

.gpws-schedule-reserve {
  margin-left: 4px;
  padding-left: 4px;
  padding-right: 4px;
  height: 18px;
  line-height: 18px;
  background: #E8F6DF;
  border-radius: 4px;
  font-size: 13px;
  font-family: Alibaba PuHuiTi;
  font-weight: 400;
  color: #5FC021;
}

.gpws-schedule-reserve-selected {
  background: rgba(252, 240, 240, 0.2);
  color: #ffffff;
}

.gpws-doctor-row {
  cursor: pointer;
  margin-top: 10px;
  margin-bottom: 10px;
}

.gpws-doctor-row:hover {
  background: rgba(136, 162, 186, 0.08) !important;
}

.gpws-doctor-row-selected {
  background: rgba(136, 162, 186, 0.08) !important;
}

</style>
